// Generated by scripts/signup_protection/emit.mjs; edit TypeScript source.
const object = (value) => value !== null && typeof value === 'object' && !Array.isArray(value) ? value : null;
const failed = (error, validationUnavailable = true) => ({ success: false, error, validationUnavailable });
const rateLimited = (remainingSeconds = 0) => failed(Number.isFinite(remainingSeconds) && remainingSeconds > 0
    ? `요청이 너무 많습니다. ${Math.ceil(remainingSeconds)}초 후 다시 시도해 주세요.`
    : '요청이 너무 많습니다. 잠시 후 다시 시도해 주세요.');
const challenge = () => failed('보안 확인이 필요합니다. 다시 확인한 뒤 시도해 주세요.');
const generic = () => failed('요청을 처리하지 못했습니다. 잠시 후 다시 시도해 주세요.');
/** Read only transport evidence; WAF/server remain the enforcement authority. */
export function signupTransportFailure(input, remainingSeconds = 0) {
    const response = object(input), payload = response?.data;
    if (response?.status === 429 || response?.httpStatus === 429)
        return rateLimited(remainingSeconds);
    if (response?.status === 202)
        return challenge();
    if (typeof payload === 'string' || !object(payload))
        return challenge();
    return null;
}
export function signupRequestFailure(input, remainingSeconds = 0) {
    const error = object(input), response = object(error?.response);
    if (error?.code === 'CLIENT_RATE_LIMIT_BACKOFF' || error?.httpStatus === 429 || error?.__rateLimitBackoff === true)
        return rateLimited(remainingSeconds);
    if (!response)
        return generic();
    const transportFailure = signupTransportFailure(response, remainingSeconds);
    if (transportFailure)
        return transportFailure;
    if (response.status !== 400)
        return generic();
    const payload = object(response.data);
    const message = payload?.error || payload?.message;
    return typeof message === 'string' && message.trim() ? failed(message, false) : generic();
}
